import React, { Component } from 'react';
import { withRouter } from 'react-router';
import pathWorkService from './PathWorkService';
import { Button } from 'reactstrap';

class PathWorkDeletePlain extends Component {
	constructor(props) {
		super(props);
		this.state = { users: [], loading: true };

		const { match } = this.props;
		this.id = match.params.id;
	}

	componentDidMount() {

	}

	handleClickOk = () => {
		const { history } = this.props;

		(async () => {
			await pathWorkService.delete(this.id);
			history.push('/pathworks');
		})();
	}

	handleClickCancel = () => {
		const { history } = this.props;

		history.push('/pathworks');
	}

	render() {
		return (
			<div>
				<h2>Are you sure you want to delete path work ?</h2>

				<button onClick={this.handleClickOk}>Yes</button>
				<button onClick={this.handleClickCancel}>No</button>
			</div>
		);
	}
}
export const PathWorkDelete = withRouter(PathWorkDeletePlain);